import React, {useState, useEffect} from 'react';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from "recharts";

import {formatDateAsString} from "../../../../../../util/StringUtil";

export const BaselineGraph = ({context}) => {

    const [data, setData] = useState(null);

    useEffect(() => {
        const problemScreen = JSON.parse(JSON.stringify(context.problemScreen));
        const {baselines} = problemScreen;

        baselines.sort((baselineOne, baselineTwo) => {
            const dateOne = new Date(baselineOne.date);
            const dateTwo = new Date(baselineTwo.date);
            return dateOne.getTime() > dateTwo.getTime();
        });

        const data = baselines.map((baseline) => {
            return {
                date: formatDateAsString(baseline.date),
                baseline: +baseline.value,
                median: +problemScreen.from,
                aim: +problemScreen.to,
            }
        });
        setData(data);
    }, []);

    return (
        <div className="baseline-graph-container">
            {data &&
            <ResponsiveContainer width='100%' height={600}>
                <LineChart data={data}>
                    <CartesianGrid/>
                    <XAxis dataKey="date"
                           stroke="black"
                           dy={50}
                           height={100}
                           interval={0}
                           angle={90}/>
                    <YAxis stroke="black"
                           dx={-10}
                           width={50}/>
                    <Tooltip/>
                    <Legend align="left"
                            verticalAlign="top"
                            wrapperStyle={{marginTop: -15, marginLeft: 50}}/>
                    <Line dataKey="median"
                          legendType="circle"
                          stroke="rgb(0,47,150)"
                          dot={false}
                          strokeWidth={3}
                          animationDuration={1000}/>
                    <Line dataKey="aim"
                          legendType="circle"
                          stroke="rgb(255,80,33)"
                          dot={false}
                          strokeWidth={3}
                          animationDuration={1000}/>
                    <Line dataKey="baseline"
                          legendType="circle"
                          stroke="rgb(26,151,255)"
                          dot={false}
                          strokeWidth={3}
                          animationDuration={1000}/>
                </LineChart>
            </ResponsiveContainer>}
        </div>
    );
}
